import { LocaleEnum } from '@/lib/enum/LocaleEnum';
import en from './en';
import enUs from './en-us';
import fr from './fr';
import lt from './lt';

export const messages = {
  [LocaleEnum.English]: en,
  [LocaleEnum.UnitedStates]: enUs,
  [LocaleEnum.French]: fr,
  lt,
};
